import React from "react";
import { Routes, Route } from "react-router-dom";

import AdminLayout from "./layouts/AdminLayout";
import AdminProtectedRoute from "./components/AdminProtectedRoute";

import AdminLogin from "./pages/AdminLogin";
import Dashboard from "./pages/Dashboard";
import Candidates from "./pages/Candidates";
import Recruiters from "./pages/Recruiters";
import Jobs from "./pages/Jobs";
import Applications from "./pages/Applications";
import Payments from "./pages/Payments";
import SubscriptionPlans from "./pages/SubscriptionPlans";
import Reports from "./pages/Reports";
import Settings from "./pages/Settings";
import Profile from "./pages/Profile";

import EditCandidate from "./pages/EditCandidate";
import EditRecruiter from "./pages/EditRecruiter";
import EditJob from "./pages/EditJob";
import EditSubscriptionPlan from "./pages/EditSubscriptionPlan";
import { Navigate } from "react-router-dom";

const AdminRoutes = () => {

    return (

        <Routes>

            {/* Public Route */}
            <Route
                path="login"
                element={<AdminLogin />}
            />

            {/* Protected Routes */}
            <Route element={<AdminProtectedRoute />}>

                <Route element={<AdminLayout />}>

                    <Route
    index
    element={
        localStorage.getItem("adminToken")
            ? <Navigate to="dashboard" replace />
            : <Navigate to="login" replace />
    }
/>

                    <Route
                        path="dashboard"
                        element={<Dashboard />}
                    />

                    <Route
                        path="candidates"
                        element={<Candidates />}
                    />

                    <Route
                        path="candidates/edit/:id"
                        element={<EditCandidate />}
                    />

                    <Route
                        path="recruiters"
                        element={<Recruiters />}
                    />

                    <Route
                        path="recruiters/edit/:id"
                        element={<EditRecruiter />}
                    />

                    <Route
                        path="jobs"
                        element={<Jobs />}
                    />

                    <Route
                        path="jobs/edit/:id"
                        element={<EditJob />}
                    />

                    <Route
                        path="applications"
                        element={<Applications />}
                    />

                    <Route
                        path="payments"
                        element={<Payments />}
                    />

                    <Route
                        path="subscription-plans"
                        element={<SubscriptionPlans />}
                    />

                    <Route
                        path="subscription-plans/edit/:id"
                        element={<EditSubscriptionPlan />}
                    />

                    <Route
                        path="reports"
                        element={<Reports />}
                    />

                    <Route
                        path="settings"
                        element={<Settings />}
                    />

                    <Route
                        path="profile"
                        element={<Profile />}
                    />

                </Route>

            </Route>

        </Routes>

    );

};

export default AdminRoutes;